import React from "react";

const WhyToBookCard = () => {
  return (
    <div>
      <h1 className="text-primary-base text-2xl font-bold">
        Why to book with us ?
      </h1>
      <div className="prose">
        <ul className="my-4">
          <li>Local Expertise</li>
          <li>Customized Itineraries</li>
          <li>Responsible Tourism</li>
          <li>Excellent Accommodation and Meals</li>
          <li>Excellent Customer Support</li>
          <li>Variety of Trekking Routes</li>
          <li>Memorable Cultural Experiences</li>
        </ul>
      </div>
    </div>
  );
};

export default WhyToBookCard;
